import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  constructor(
    public router: Router,
    private authService: AuthenticationService,
    private dataService: DataService,
    private userService: UserService) { }

  ngOnInit(): void {
    this.hiddenLoading();
    this.getMenu();
  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }

  private hiddenLoading(): void {
    setTimeout(() => {
      if (this.authService.currentUserValue) {
        this.authService.currentUserValue.licence ?
          this.router.navigate(['/home']) :
          this.router.navigate(['/link-your-account']);
      } else {
        this.router.navigate(['/home']);
      }
    }, 2500);
  }
}
